import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import AgendamentoApi from '@/Apis/Agendamento/Services/AgendamentoApi'
import { ComorbidadePayloadProps, ComorbidadeProps } from '@/types/interfaces/Comorbidades'

type ModalMode = 'CREATE' | 'EDIT'

type Modal = {
    isOpen: boolean,
    mode: ModalMode
}

@Module({ namespaced: true, name: 'BackofficeComorbidadesStore' })
export default class BackofficeComorbidadesStore extends VuexModule {
  private comorbidadeDefault: ComorbidadeProps = {
    descricao: '',
    status: 'Ativo',
    hisId: '',
  }

  public hospitalId: string = ''
  public comorbidades: ComorbidadeProps[] = []
  public comorbidadeSelected: ComorbidadeProps = { ...this.comorbidadeDefault }

  public modal: Modal = {
    isOpen: false,
    mode: 'CREATE',
  }

  @Mutation
  setModal(modal: Modal) {
    this.modal = modal
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setComorbidades(comorbidades: ComorbidadeProps[]) {
    this.comorbidades = comorbidades
  }

  @Mutation
  clearComorbidades() {
    this.comorbidades = []
  }

  @Mutation
  setComorbidadeSelected(comorbidade: ComorbidadeProps) {
    this.comorbidadeSelected = { ...this.comorbidadeDefault, ...comorbidade }
  }

  @Mutation
  clearComorbidadeSelected() {
    this.comorbidadeSelected = { ...this.comorbidadeDefault }
  }

  @Action
  async getComorbidadesByHospitalId(hospitalId?: string) {
    if (hospitalId === this.hospitalId && this.comorbidades.length > 0) {
      return []
    }
    const response = await AgendamentoApi.getComorbidadesByHospitalId(hospitalId || this.hospitalId)
    if (response.success) {
      this.context.commit('setComorbidades', response.data)
    }
    return []
  }

  @Action
  async upsertComorbidade(comorbidade: ComorbidadeProps) {
    const comorbidadePayload: ComorbidadePayloadProps = {
      ...comorbidade,
      hospitalId: this.hospitalId,
    }
    const response = await AgendamentoApi.upsertComorbidade(comorbidadePayload)
    return response
  }
}
